import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getIndexProtectorLabel} from "../../shared/common";
import classes from './Introduction.css'
import * as actionTypes from '../../store/actions';
import * as actionCreators from '../../store/actionCreators';
import AdvisorAuth from "../../services/AdvisorAuth";
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel
} from "react-accessible-accordion";
import moment from "moment";

/// TODO: Update the Barclay row to get the data it needs from the BE once the BE endpoint is ready.

export class Introduction extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submitted: false
        };

        this.props.getProductsConfiguration();

        this.goToAnnuityCalculator = this.goToAnnuityCalculator.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        if (this.props.updateMenuState) {
            this.props.updateMenuState();
        }
    }

    componentWillReceiveProps(nextProps) {

    }

    handleChange(e) {
        const {name, value} = e.target;
        this.props.setSelectedIndexProtector(value);
    }

    resetInfo() {
        this.props.updateClientInfo("firstName", "");
        this.props.updateClientInfo("lastName", "");
        this.props.updateClientInfo("dateOfBirth", moment().subtract(1, "days"));
        this.props.updateAccountInfo(0.0);
        this.props.updateAllocationType(true);
        this.props.updateAllocationId("CHOOSE");
        this.props.updateIsValid(true);
        if (this.props.indexProtector === "INDEX ACHIEVER") {
            const data = {
                sp500Minus10Percentage: 50.0,
                sp500OneYear50Percentage: 0.0,
                sp500OneYear10Percentage: 50.0,
                sp500SixYear10Percentage: 0.0,
                eafeOneYear50Percenpage: 0.0,
                eafeOneYear10Percenpage: 0.0,
                realEstateOneYear50Percentage: 0.0,
                realEstateOneYear10Percentage: 0.0,
                spdrOneYear50Percentage: 0.0,
                spdrOneYear10Percentage: 0.0
            };
            this.props.updateIndexAchieverIndex(data);
            this.props.updateIndexArchieverAllocationPercentage(0.0);
        } else if (this.props.indexProtector === "INDEX ACHIEVER ADVISORY") {
            const data = {
                sp500Minus10Percentage: 0.0,
                sp500OneYear50Percentage: 50.0,
                sp500OneYear10Percentage: 0.0,
                sp500SixYear10Percentage: 50.0,
                eafeOneYear50Percenpage: 0.0,
                eafeOneYear10Percenpage: 0.0,
                realEstateOneYear50Percentage: 0.0,
                realEstateOneYear10Percentage: 0.0,
                spdrOneYear50Percentage: 0.0,
                spdrOneYear10Percentage: 0.0
            };
            this.props.updateIndexAchieverIndex(data);
            this.props.updateIndexArchieverAllocationPercentage(0.0);
        } else {
            const data = {
                yr: 0.0,
                sandp: 50.0,
                sandrcntl: 0.0,
                retiree: 0.0,
                interestRate: 0.0,
                indexEAFE: 50.0,
                barclay: 0.0
            };
            this.props.updateIP7Index(data);
            this.props.updateIP7AllocationPercentage(0.0);
        }
    }

    goToAnnuityCalculator() {
        this.resetInfo();
        this.setState({submitted: true});

        if (this.props.indexProtector) {
            this.props.loadDefaultAllocationModels(this.props.indexProtector, this.props.history);
        }
    }

    render() {
        const {submitted} = this.state;
        const showError = this.props.indexProtector === null ? true : false;
        let indexProtectors = {
            "IP4": {},
            "IP5 MVA": {},
            "IP7": {},
            "IP5": {}
        };

        let indexProtectorsRila = {
            "INDEX ACHIEVER": {},
            "INDEX ACHIEVER ADVISORY": {}
        }

        for (let product of this.props.productReducer.productsData) {
            indexProtectors[product.key] = product;
        }
        for (let product of this.props.productReducer.rilaData) {
            indexProtectorsRila[product.key] = product;
        }

        let showIP4 = false;
        let showIP5MVA = false;
        let showIP5 = false;
        let showIP7 = false;

        if (this.props.isAuthorized) {
            if (this.props.companyName === "RAYMOND_JAMES") {
                showIP4 = indexProtectors["IP4"].userGroupRJ;
                showIP5MVA = indexProtectors["IP5 MVA"].userGroupRJ;
                showIP7 = indexProtectors["IP7"].userGroupRJ;
                showIP5 = indexProtectors["IP5"].userGroupRJ;
            } else if (this.props.companyName === "WELLS_FARGO") {
                showIP4 = indexProtectors["IP4"].userGroupWellsFargo;
                showIP5MVA = indexProtectors["IP5 MVA"].userGroupWellsFargo;
                showIP7 = indexProtectors["IP7"].userGroupWellsFargo;
                showIP5 = indexProtectors["IP5"].userGroupWellsFargo;
            } else if (this.props.companyName === "MMFA") {
                showIP4 = indexProtectors["IP4"].userGroupMmfa;
                showIP5MVA = indexProtectors["IP5 MVA"].userGroupMmfa;
                showIP7 = indexProtectors["IP7"].userGroupMmfa;
                showIP5 = indexProtectors["IP5"].userGroupMmfa;
            } else {
                showIP4 = indexProtectors["IP4"].userGroupGaig;
                showIP5MVA = indexProtectors["IP5 MVA"].userGroupGaig;
                showIP7 = indexProtectors["IP7"].userGroupGaig;
                showIP5 = indexProtectors["IP5"].userGroupGaig;
            }
        }

        let numberOfIpDisplayed = 0;
        if (showIP4) numberOfIpDisplayed++;
        if (showIP5MVA) numberOfIpDisplayed++;
        if (showIP7) numberOfIpDisplayed++;
        if (showIP5) numberOfIpDisplayed++;

        let numberOfIpDisplayedRila = 0;

        let percentageWidth = 0;
        if (numberOfIpDisplayed == 1) {
            percentageWidth = 50;
        } else if (numberOfIpDisplayed == 2) {
            percentageWidth = 33
        } else if (numberOfIpDisplayed == 3) {
            percentageWidth = 25;
        } else if (numberOfIpDisplayed == 4) {
            percentageWidth = 20;
        }

        let percentageWidthRila = 0;
        if (numberOfIpDisplayedRila == 1) {
            percentageWidthRila = 50;
        } else if (numberOfIpDisplayedRila == 2) {
            percentageWidthRila = 25
        }

        console.log(indexProtectors);

        return (
            <div className={classes.introduction}>
                <div className={classes.textContainer}>
                    <p>
                        By using a fee-based fixed-indexed or registered index-linked annuity as an asset class, this
                        tool provides a side-by-side comparison of a portfolio with and without a fee-based product.
                        Monte Carlo simulations illustrate a range of possible outcomes and the benefits of having
                        complete or partial downside protection, while allowing participation in market upside.
                    </p>
                    <p>
                        This simulation allows you to see and analyze different results based on market performance and
                        interest rate changes, including the impact on accumulation, standard deviation and Sharpe
                        Ratio.
                    </p>
                </div>
                <Accordion allowZeroExpanded preExpanded={['fia']}>
                    <AccordionItem uuid="fia">
                        <AccordionItemHeading>
                            <AccordionItemButton>Fixed Index Annuities</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            {numberOfIpDisplayed !== 0 && (
                                <div className={classes.ratesContainer}>
                                    <div className={classes.row + ' ' + classes.rowTitle}>
                                        <div className={classes.column + ' ' + classes.rowTitle}
                                             style={{width: percentageWidth + "%"}}>
                                            Illustrated rates
                                        </div>
                                        {showIP7 && (
                                            <div className={classes.column + ' ' + classes.columnTitle}
                                                 style={{width: percentageWidth + "%"}}>{getIndexProtectorLabel("7")}</div>
                                        )}
                                        {showIP5MVA && (
                                            <div className={classes.column + ' ' + classes.columnTitle}
                                                 style={{width: percentageWidth + "%" }}>{getIndexProtectorLabel("5 MVA")}</div>
                                        )}
                                        {showIP4 && (
                                            <div className={classes.column + ' ' + classes.columnTitle}
                                                 style={{width: percentageWidth + "%" }}>{getIndexProtectorLabel("4")}</div>
                                        )}
                                        {showIP5 && (
                                            <div className={classes.column + ' ' + classes.columnTitle}
                                                 style={{width: percentageWidth + "%" }}>{getIndexProtectorLabel("5")}</div>
                                        )}
                                    </div>
                                    <div className={classes.row + ' ' + classes.rowSubtitle}>
                                        <div className={classes.column}
                                             style={{width: percentageWidth + "%" }}>
                                        </div>
                                        {showIP7 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                Early withdrawal charges and MVAs last 7 years
                                            </div>
                                        )}
                                        {showIP5MVA && (
                                            <div className={classes.column + ' ' + classes.rowSubtitle}
                                                 style={{width: percentageWidth + "%"}}>
                                                MVAs last 5 years
                                            </div>
                                        )}
                                        {showIP4 && (
                                            <div className={classes.column + ' ' + classes.rowSubtitle}
                                                 style={{width: percentageWidth + "%"}}>
                                                Early withdrawal charges last 4 years
                                            </div>
                                        )}
                                        {showIP5 && (
                                            <div className={classes.column + ' ' + classes.rowSubtitle}
                                                 style={{width: percentageWidth + "%"}}>
                                                Early withdrawal charges last 5 years
                                            </div>
                                        )}
                                    </div>
                                    <div className={classes.row}>
                                        <div className={classes.column + ' ' + classes.rowTitle_white}
                                             style={{width: percentageWidth + "%"}}>S&P 500
                                        </div>
                                        {showIP7 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP7"].sp500.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                        {showIP5MVA && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP5 MVA"].sp500.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                        {showIP4 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP4"].sp500.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                        {showIP5 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP5"].sp500.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                    </div>
                                    <div className={classes.row}>
                                        <div className={classes.column + ' ' + classes.rowTitle_white}
                                             style={{width: percentageWidth + "%"}}>S&P 500 Risk Control
                                        </div>
                                        {showIP7 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP7"].riskControl.value.toFixed(2)}% par. rate
                                            </div>
                                        )}
                                        {showIP5MVA && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP5 MVA"].riskControl.value.toFixed(2)}% par. rate
                                            </div>
                                        )}
                                        {showIP4 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP4"].riskControl.value.toFixed(2)}% par. rate
                                            </div>
                                        )}
                                        {showIP5 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                N/A
                                            </div>
                                        )}
                                    </div>
                                    <div className={classes.row}>
                                        <div className={classes.column + ' ' + classes.rowTitle_white}
                                             style={{width: percentageWidth + "%"}}>S&P U.S Retiree Spending
                                        </div>
                                        {showIP7 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP7"].retireeSpending.value.toFixed(2)}% par. rate
                                            </div>
                                        )}
                                        {showIP5MVA && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP5 MVA"].retireeSpending.value.toFixed(2)}% par. rate
                                            </div>
                                        )}
                                        {showIP4 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP4"].retireeSpending.value.toFixed(2)}% par.rate
                                            </div>
                                        )}
                                        {showIP5 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                N/A
                                            </div>
                                        )}
                                    </div>
                                    <div className={classes.row}>
                                        <div className={classes.column + ' ' + classes.rowTitle_white}
                                             style={{width: percentageWidth + "%"}}>iShares U.S. Real Estate
                                        </div>
                                        {showIP7 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP7"].yir.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                        {showIP5MVA && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP5 MVA"].yir.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                        {showIP4 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP4"].yir.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                        {showIP5 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                N/A
                                            </div>
                                        )}
                                    </div>
                                    <div className={classes.row}>
                                        <div className={classes.column + ' ' + classes.rowTitle_white}
                                             style={{width: percentageWidth + "%"}}>iShares MSCI EAFE
                                        </div>
                                        {showIP7 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP7"].efa.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                        {showIP5MVA && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP5 MVA"].efa.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                        {showIP4 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP4"].efa.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                        {showIP5 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP5"].efa.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                    </div>
                                    <div className={classes.row}>
                                        <div className={classes.column + ' ' + classes.rowTitle_white}
                                             style={{width: percentageWidth + "%"}}>First Trust Barclays Edge Index with cap
                                        </div>

                                        {showIP7 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP7"].barclay.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                        {showIP5MVA && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP5 MVA"].barclay.value.toFixed(2)}% cap
                                            </div>
                                        )}
                                        {showIP4 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                N/A
                                            </div>
                                        )}
                                        {showIP5 && (
                                            <div className={classes.column} style={{width: percentageWidth + "%"}}>
                                                {indexProtectors["IP5"].barclay.value.toFixed(2)}% cap
                                            </div>
                                        )}

                                    </div>
                                </div>
                            )}
                            <div className={classes.productSelection}>
                                <p> Select the product you'd like to simulate:</p>
                                {showIP7 && (
                                    <div className={classes.radio}>
                                        <label className={classes.radioContainer}>{getIndexProtectorLabel("7")}
                                            <input type="radio" name="indexProtector" value="7" onChange={this.handleChange}/>
                                            <span className={classes.checkmark}></span>
                                        </label>
                                    </div>
                                )}
                                {showIP5MVA && (
                                    <div className={classes.radio}>
                                        <label className={classes.radioContainer}>{getIndexProtectorLabel("5 MVA")}
                                            <input type="radio" name="indexProtector" value="5 MVA" onChange={this.handleChange}/>
                                            <span className={classes.checkmark}></span>
                                        </label>
                                    </div>
                                )}
                                {showIP4 && (
                                    <div className={classes.radio}>
                                        <label className={classes.radioContainer}>{getIndexProtectorLabel("4")}
                                            <input type="radio" name="indexProtector" value="4" onChange={this.handleChange}/>
                                            <span className={classes.checkmark}></span>
                                        </label>
                                    </div>
                                )}
                                {showIP5 && (
                                    <div className={classes.radio}>
                                        <label className={classes.radioContainer}>{getIndexProtectorLabel("5")}
                                            <input type="radio" name="indexProtector" value="5" onChange={this.handleChange}/>
                                            <span className={classes.checkmark}></span>
                                        </label>
                                    </div>
                                )}
                                {submitted && !this.props.indexProtector &&
                                <div className={classes.error}>You have to select the products before you can continue.</div>
                                }
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
                <div className={classes.row + ' ' + classes.buttonContainer}>
                    <button className={classes.button + ' ' + classes.ContinueButton}
                            onClick={this.goToAnnuityCalculator}>CONTINUE
                    </button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        indexProtector: state.globalState.indexProtector,
        productReducer: state.productReducer,
        isAuthorized: state.globalState.isAuthorized,
        companyName: state.globalState.companyName,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateMenuState: () => dispatch({type: actionTypes.MENU_INTRODUCTION}),
        setSelectedIndexProtector: (val) => dispatch({
            type: actionTypes.SET_SELECTED_INDEX_PROTECTOR,
            value: val
        }),
        getProductsConfiguration: () => dispatch(actionCreators.getProductsConfiguration()),
        loadDefaultAllocationModels: (indexProtector, history) => dispatch(actionCreators.loadDefaultAllocationModels(indexProtector, history)),
        updateIndexAchieverIndex: (data) => dispatch({type: actionTypes.UPDATE_INDEX_ALLOCATIONS_RILA, data: data}),
        updateIP7Index: (data) => dispatch({type: actionTypes.UPDATE_INDEX_ALLOCATIONS, data: data}),
        updateClientInfo: (key, value) => dispatch({type: actionTypes.CLIENTINFO_UPDATE, data:{
                key: key,
                value: value
            }}),
        updateAccountInfo: (value) => dispatch({type: actionTypes.ACCOUNT_UPDATE, value: value}),
        updateIP7AllocationPercentage: (value) => dispatch({
            type: actionTypes.IP7PERCENTAGE_UPDATE,
            value: value
        }),
        updateIndexArchieverAllocationPercentage: (value) => dispatch({
            type: actionTypes.INDEXARCHIEVERPERCENTAGE_UPDATE,
            value: value
        }),
        updateAllocationType: (isDefault) => dispatch({type: actionTypes.UPDATE_ALLOCATION_TYPE, isDefault: isDefault}),
        updateAllocationId: (value) => dispatch({type: actionTypes.UPDATE_ALLOCATION_ID, allocationId: value}),
        updateIsValid: (isValid) => dispatch({type: actionTypes.UPDATE_IS_VALID, isValid: isValid})
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Introduction);



// WEBPACK FOOTER //
// ./src/containers/Introduction/Introduction.js